const peiStates = {
  State: 43,
};

export default peiStates;
